import { parseAmount } from "@frontend/utils/amount";

export type PriceChange = {
  /** What the price gains or loses, in percent. */
  percent: number;
  /** The price the amendment replaces. */
  previous: number;
};

/**
 * What an amendment does to the price it follows. Null while either side is
 * missing, and on a previous price of zero, which no percentage describes.
 */
export function priceChange(
  previousPrice: string | null,
  price: string | null,
): PriceChange | null {
  const previous = parseAmount(previousPrice);
  const current = parseAmount(price);

  if (null === previous || null === current || 0 === previous) {
    return null;
  }

  return { percent: ((current - previous) / previous) * 100, previous };
}
